// Snowflake: Raleigh Corporate
const aflacClientList = ['87c1b0eb-6503-4cab-936e-e26eb8e9d711']

export default aflacClientList
